import { ReactNode } from 'react';
import { useDraggable } from '../hooks/useDraggable';

interface FloatingActionsProps {
  children: ReactNode;
  storageKey?: string;
}

export function FloatingActions({ children, storageKey = 'floating-actions-position' }: FloatingActionsProps) {
  const { position, isDragging, dragRef, dragHandlers } = useDraggable({
    initialPosition: { x: 24, y: 24 },
    storageKey,
  });

  return (
    <div
      ref={dragRef}
      className={`fixed flex items-center gap-2 p-2 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 z-40 ${
        isDragging ? 'cursor-grabbing' : ''
      }`}
      style={{
        right: position.x,
        bottom: position.y,
        userSelect: 'none',
      }}
    >
      {/* Drag handle */}
      <div
        {...dragHandlers}
        className={`flex items-center justify-center w-6 h-6 rounded-md text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 ${
          isDragging ? 'cursor-grabbing' : 'cursor-grab'
        }`}
        title="Drag to reposition"
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
        </svg>
      </div>
      <div className="w-px h-6 bg-gray-200 dark:bg-gray-700" />
      {children}
    </div>
  );
}
